<template>
  <div class="container">
    <component :is="tag" class=" title-static">
      {{ props.title }}
      <hr class="simple-hr">
    </component>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  tag: {
    type: String,
    default: 'div',
  },
});
</script>

<style lang="scss" scoped>
.title-static {
  padding-top: 20px;
  font-size: 18px;
  font-weight: bold;
  color: $dark;
  text-align: left;

  >.simple-hr {
    width: 100%;
    color: $dark;
    text-align: right;
  }
}
</style>
